function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 2.5,
  cy: 2.5,
  r: 2.5,
  fill: "#94A2AB"
});

var SvgBullet = function SvgBullet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 5,
    fill: "none"
  }, props), _ref);
};

export default SvgBullet;